module.exports = __webpack_public_path__ + "static/media/shannon.084c7157.png";